<template>
  <form class="register-form" @submit.prevent="onSignup">
    <social-login google-label="Register with Google" />

    <label class="divider">Or register in with your email</label>

    <error-message
      v-if="!form.$getError('email') && !form.$getError('password')"
      class="text-center mb-3"
      sign=""
      :error="form.$errorMessage"
    ></error-message>

    <b-form-group class="col-12 px-0">
      <custom-input
        :value="form.email"
        type="email"
        placeholder="Email address"
        autofocus
        :disabled="form.$busy"
        :is-invalid="form.$getError('email')"
        @change="emailValue"
        autocomplete="off"
      ></custom-input>
      <error-message :error="form.$getError('email')"></error-message>
    </b-form-group>

    <b-form-group class="col-12 px-0">
      <custom-input
        v-model="form.password"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Password"
        :disabled="form.$busy"
        :is-invalid="form.$getError('password')"
        autocomplete="off"
      >
        <template slot="icon">
          <b-icon
            v-if="!showPassword"
            class="show"
            icon="eye"
            aria-hidden="true"
            @click="togglePassword(true)"
          ></b-icon>
          <b-icon
            v-else
            class="hide"
            icon="eye-slash"
            aria-hidden="true"
            @click="togglePassword(false)"
          ></b-icon>
        </template>
      </custom-input>
      <error-message :error="form.$getError('password')"></error-message>
    </b-form-group>

    <b-button
      type="submit"
      class="submit-btn"
      variant="primary"
      block
      :disabled="form.$busy"
    >
      <b-spinner v-if="form.$busy" small></b-spinner>
      Register
    </b-button>

    <div class="terms-conditions">
      <p>
        By signing up, I agree to the
        <router-link to="/terms-and-conditions"
          >Terms and Conditions</router-link
        >
        and
        <router-link to="/privacy-policy">Privacy Policy</router-link>
      </p>
    </div>
  </form>
</template>
<script>
/**
 * ==================================================================================
 * Login form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Form from '@/utils/form'
import CustomInput from '@/components/inputs/CustomInput'
import ErrorMessage from '@/components/inputs/ErrorMessage'
import SocialLogin from '@/components/SocialLogin'
import IsEmail from 'isemail'

export default {
  components: {
    CustomInput,
    ErrorMessage,
    SocialLogin
  },
  data: function () {
    return {
      showPassword: false,
      form: new Form({
        email: null,
        password: null
      })
    }
  },

  methods: {
    ...mapActions({
      register: 'auth/register'
    }),

    async onSignup() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await this.register({
        email: this.form.email,
        password: this.form.password,
        password_confirmation: this.form.password
      })
        .then(() => {
          this.$router.push({
            name: 'auth.verify-page',
            params: {
              id: 'email'
            }
          })
        })
        .catch((error) => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
        })
    },

    togglePassword(bool) {
      this.showPassword = bool
    },

    emailValue(val) {
      this.form.email = val
      if (val !== '' && !IsEmail.validate(val)) {
        this.form.$setError('email', 'Must be a valid email address')
      } else {
        this.form.$clearError('email')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.register-form {
  width: 100%;
  max-width: 410px;
  margin: 40px auto;

  .divider {
    margin: 35px auto;
  }

  .social-register {
    width: 100%;
  }

  .forgot-password {
    font-size: 0.95rem;
    font-weight: 600;
    margin-bottom: 50px;
  }

  .submit-btn {
    margin-top: 50px;
  }

  .terms-conditions {
    font-size: 0.95rem;
    width: 80%;
    margin: 40px auto 0 auto;

    a {
      text-decoration: underline;
    }
  }

  ::-ms-reveal {
    display: none;
  }
}
</style>
